var path = '/static/assets/khapps/fms_app/myfarm/map/sidebar/soil-sample/soil-sample-sidebar.directive.html';
var html = "<soil-sample-sidebar sample=\"feature.properties\"></soil-sample-sidebar>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;